import * as React from "react";
import { ChoiceList } from "@cmsgov/design-system-core";
import { camelize } from "../services/Utility";
import { FormSelectChoice } from "./../../refdata/FilterOptions";
import { summarizeFilterSelections } from "./../../common/services/Filters";

export interface Props {
  label: string;
  selectedValues: string[];
  filterName: string;
  choices: FormSelectChoice[];
  onAdd: (changed: string[]) => void;
  onRemove: (changed: string[]) => void;
}

function MultiSelectCheckbox({
  label,
  selectedValues,
  filterName,
  choices,
  onAdd,
  onRemove,
}: Props) {
  selectedValues = selectedValues.filter(item => {
    return item !== "";
  });
  const selectedAll = choices.length === selectedValues.length;
  const selectAllLabel = `${label  }_Select All / None`;
  const allValues = choices.map((choice: any) => {
    return choice.value;
  });

  const selectAllChoice = {
    label: "Select All / None",
    value: selectAllLabel,
    checked: selectedAll,
  };
  const choiceChanged = (event: any) => {
    if (event.target.checked) {
      if (event.target.value === selectAllLabel) {
        onAdd(allValues);
      } else {
        onAdd([event.target.value]);
      }
    } else {
      if (event.target.value === selectAllLabel) {
        onRemove(allValues);
      } else {
        onRemove([event.target.value]);
      }
    }
  };

  const allChoices = [
    selectAllChoice,
    ...choices.map((c: any) => {
      c.checked = selectedValues.indexOf(c.value) > -1;
      return c;
    }),
  ];
  const printSummary = summarizeFilterSelections(
    filterName,
    selectedValues,
    null,
  );

  // TODO: Want to make this uniform with the other checkbox component (<Choice /> in ./SubSectionFields.tsx) used in Historical App.
  // ChoiceList does not allow for class to be applied to root <div> or for size adjustment on Checkbox type
  return (
    <div>
      <div className="screenOnly">
        <ChoiceList
          choices={allChoices}
          multiple={true}
          type="checkbox"
          label={label}
          name={camelize(label)}
          onChange={choiceChanged}
        />
      </div>
      {/* TODO: Determine whether we want to display "All" opposed to the values even if checked */}
      <div className="printOnly">{printSummary}</div>
    </div>
  );
}

export default MultiSelectCheckbox;
